module.exports = __webpack_public_path__ + "static/media/03_02.2c890a32.png";